import React from 'react'
import styled from 'styled-components'

import { useTranslation } from '@root/shared/localization'

import { ShortcutCommandShow } from './shortcut-command-show'

import type { ShortcutId } from '../shortcut-id'
import type { ShortcutRouteHandler } from '../shortcut-router'
import type { Array } from '@blade/std-lib'

export interface ShortcutCheatSheetListProps {
  commands: Array.NonEmptyReadonlyArray<[ShortcutId, ShortcutRouteHandler]>
}
export const ShortcutCheatSheetList = ({
  commands,
}: ShortcutCheatSheetListProps) => {
  const { t } = useTranslation()

  return (
    <List>
      {commands.map(([id, command]) => {
        return (
          <Item key={id}>
            <Title>{t(command.description)}</Title>
            <Description>
              <ShortcutCommandShow commandShow={command.commandShow} />
            </Description>
          </Item>
        )
      })}
    </List>
  )
}

const List = styled.ul`
  all: unset;
  display: flex;
  flex-direction: column;
`
const Item = styled.li`
  all: unset;
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 8px;
  padding: 10px;
  align-items: center;
  justify-content: space-between;
  color: var(--text-11);
  background: var(--background-2);
  position: relative;

  &:nth-child(even) {
    background: rgba(var(--background-2-rgb), 0.5);
  }

  &:hover {
    background: var(--backgroundA-3);
  }

  &:first-child {
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
  }

  &:last-child {
    border-bottom-left-radius: 12px;
    border-bottom-right-radius: 12px;
  }

  &:not(:last-child) {
    border-bottom: 1px solid var(--backgroundA-3);
    /* &:after {
      content: '';
      display: block;
      height: 1px;
      position: absolute;
      bottom: 0;
      left: 12px;
      right: 12px;
      background: var(--backgroundA-3);
    } */
  }
`
const Title = styled.div`
  color: var(--text-12);
  font-size: 16px;
  font-weight: 500;
  line-height: 16px;
  font-size: 16px;
  font-weight: 500;
  line-height: 16px;
`
const Description = styled.div``
